/* eslint-disable max-classes-per-file */

import { console as ReproConsole } from './utility/console';

/*
  See https://repro.esa.io/posts/35307 for more details
  \x09 -> tab
  \x0a -> LF
  \x0d -> CR
  \x20 -> half width space
*/
const WHITESPACE_CHARS = ['\x09', '\x0a', '\x0d', '\x20'];
const LEADING_WHITESPACE_REGEXP = new RegExp(`^(${WHITESPACE_CHARS.join('|')})+`);
const TRAILING_WHITESPACE_REGEXP = new RegExp(`(${WHITESPACE_CHARS.join('|')})+$`);

class NameNormalizer {
  public static process(name: string): string {
    if (typeof name !== 'string') {
      return name;
    }

    let normalizedName = name;

    if (normalizedName.match(LEADING_WHITESPACE_REGEXP)) {
      normalizedName = normalizedName.replace(LEADING_WHITESPACE_REGEXP, '');
      ReproConsole.warn('Removed leading whitespace in user profile key or event name');
    }

    if (normalizedName.match(TRAILING_WHITESPACE_REGEXP)) {
      normalizedName = normalizedName.replace(TRAILING_WHITESPACE_REGEXP, '');
      ReproConsole.warn('Removed trailing whitespace in user profile key or event name');
    }

    return normalizedName;
  }
}

export class UserProfileKeyNormalizer extends NameNormalizer {}
export class CustomEventNameNormalizer extends NameNormalizer {}
